import { createGlobalStyle } from 'styled-components'
import { normalize } from 'polished'

const theme = {
  fonts: {
    regular: 'Montserrat, Open Sans, sans-serif'
  },
  radius: '4px',
  width: 74,
  colors: {
    primary: {
      shade50: '#e8f5e9',
      shade100: '#c8e6c9',
      shade200: '#a5d6a7',
      shade300: '#81c784',
      shade400: '#66bb6a',
      shade500: '#4caf50',
      shade600: '#43a047',
      shade700: '#388e3c',
      shade800: '#2e7d32',
      shade900: '#1b5e20'
    },

    danger: '#e53835',
    warning: '#fdd835',
    success: '#43a047',

    white: '#fff',
    black: '#000a12',

    gray: {
      shade50: '#eceff1',
      shade100: '#cfd8dc',
      shade200: '#b0bec5',
      shade300: '#90a4ae',
      shade400: '#78909c',
      shade500: '#607d8b',
      shade600: '#546e7a',
      shade700: '#455a64',
      shade800: '#37474f',
      shade900: '#263238'
    }
  },
  mixins: {
    icon: `
      font-family: 'Material Icons';
      font-weight: normal;
      font-style: normal;
      font-size: 24px;  /* Preferred icon size */
      display: inline-block;
      line-height: 1;
      text-transform: none;
      letter-spacing: normal;
      word-wrap: normal;
      white-space: nowrap;
      direction: ltr;

      /* Support for all WebKit browsers. */
      -webkit-font-smoothing: antialiased;
      /* Support for Safari and Chrome. */
      text-rendering: optimizeLegibility;

      /* Support for Firefox. */
      -moz-osx-font-smoothing: grayscale;

      /* Support for IE. */
      font-feature-settings: 'liga';
    `
  }
}

/* eslint-disable no-unused-expressions */
export const GlobalStyle = createGlobalStyle`
  ${normalize()}

  html, body, #app-root, main {
    height: 100%;
    background-color: ${theme.colors.gray.shade50};
  }

  .no-scroll {
    overflow: hidden;
  }

  *, *:before, *:after {
    box-sizing: border-box;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`

export default theme



// WEBPACK FOOTER //
// ./src/theme/index.js